import { LocaleString as LocaleStringType } from '__generated__/graphql-sanity';
import { LocaleString } from 'groq/shared/LocaleString';
import { LinkObject, LinkObjectType } from 'groq/objects/LinkObject';
import { Maybe } from 'utils/types';

// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/objects/cta.ts

const LinkVariant = {
  Black: 'black',
  Primary: 'primary',
  Secondary: 'secondary',
  White: 'white',
} as const;

type LinkVariant = (typeof LinkVariant)[keyof typeof LinkVariant];

export type CallToActionObjectType = {
  _key?: Maybe<string>;
  _type: string;
  category?: Maybe<LocaleStringType>;
  article?: Maybe<string>;
  marketing?: Maybe<string>;
  support?: Maybe<string>;
  product?: Maybe<string>;
  core?: Maybe<string>;
  absolute?: Maybe<string>;
  newtab?: Maybe<boolean>;
  outlined?: Maybe<boolean>;
  popup?: Maybe<boolean>;
  query?: Maybe<string>;
  title?: Maybe<string>;
  variant?: Maybe<LinkVariant>;
  action?: Maybe<string>;
  width?: Maybe<'auto' | 'equal' | 'full' | 'fixed'>;
  linkConfig?: Maybe<LinkObjectType>;
};

export const CallToActionObject = field => `
  ${field} {
    ...,
    ${LocaleString('title')},
    "category": route -> urls,
    "article": "articles/" + article -> puid.current,
    "marketing": marketing -> url.current,
    "support": support -> url.current,
    "newtab": coalesce(linkConfig.newtab, newtab),
    "popup": coalesce(linkConfig.popup, popup),
    "query": coalesce(linkConfig.query, query),
    "action": coalesce(linkConfig.action, action),
    "absolute": link,
    ${LinkObject('linkConfig')},
  }
`;
